export default __webpack_public_path__ + "static/media/empty.f3ee1cdd.png";